import React, { useState } from 'react';
import { autenticar } from '../../utils/auth';
import './Login.css';

function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    if (carregando) return;
    setErro('');
    setCarregando(true);
    try {
      const resultado = await autenticar(usuario, senha);
      if (resultado.success) {
        setSenha('');
        onLogin(resultado);
      } else {
        setErro(resultado.error || 'Could not sign in.');
      }
    } catch (err) {
      setErro(err && err.message ? err.message : 'Authentication error.');
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <img src="/sipremo_logo_white.svg" alt="SIPREMO" className="login-logo-img" />
        </div>

        <h1 className="login-title">Sign in</h1>
        <p className="login-subtitle">SIPREMO Meteorological Data System</p>

        <form className="login-form" onSubmit={handleSubmit}>
          {erro && <div className="login-error" role="alert">{erro}</div>}

          <div className="login-field">
            <label className="login-label" htmlFor="login-usuario">Username</label>
            <input
              id="login-usuario"
              className="login-input"
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              placeholder="sipremo"
              autoComplete="username"
              disabled={carregando}
            />
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="login-senha">Password</label>
            <div className="login-password-row">
              <input
                id="login-senha"
                className="login-input login-password-input"
                type={mostrarSenha ? 'text' : 'password'}
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                disabled={carregando}
              />
              <button
                type="button"
                className="login-password-toggle"
                onClick={() => setMostrarSenha((v) => !v)}
                aria-label={mostrarSenha ? 'Hide password' : 'Show password'}
              >
                {mostrarSenha ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <button type="submit" className="login-submit" disabled={carregando}>
            {carregando ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <p className="login-note">
          The session expires automatically after 12 hours.
        </p>
      </div>
    </div>
  );
}

export default Login;
